export default function serviceWorkerRegistration() {
  let _url = `${process.env.PUBLIC_URL}/service-worker.js`;
  navigator?.serviceWorker.register(_url).then((resp) => {
    console.warn("Service Worker Registered.");
  });
}
